var _sodipodiNamedview, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownIconDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200mm",
    height: "200mm",
    viewBox: "0 0 200 200",
    id: "svg9015",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "icon2.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview9017",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDocumentUnits: "mm",
    showgrid: "false",
    inkscapeZoom: 0.72515432,
    inkscapeCx: 376.47159,
    inkscapeCy: 432.32177,
    inkscapeWindowWidth: 1920,
    inkscapeWindowHeight: 1005,
    inkscapeWindowX: -9,
    inkscapeWindowY: -9,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "layer1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9012"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13488-0",
    transform: "matrix(1.4285715,0,0,1.4285715,-70.382636,-180.50146)",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-6",
    width: 20,
    height: 20,
    x: -196.35101,
    y: 69.267845,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-0-1",
    width: 20,
    height: 20,
    x: -196.35101,
    y: 149.26784,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-0-7-5",
    width: 20,
    height: 20,
    x: -216.35101,
    y: 89.267845,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-8-6",
    width: 20,
    height: 20,
    x: -176.35101,
    y: 169.26784,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-8-3",
    width: 20,
    height: 20,
    x: -176.35101,
    y: 49.267841,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-0-4-7",
    width: 20,
    height: 20,
    x: -236.35101,
    y: 109.26785,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-0-6-5",
    width: 20,
    height: 20,
    x: -216.35101,
    y: 129.26785,
    transform: "rotate(-90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIconDefault);
export default __webpack_public_path__ + "static/media/dropdown-icon-default.46b0faad26cdfa505bb9161818bad989.svg";
export { ForwardRef as ReactComponent };